import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import WidgetTable from '@cms/components/tables/widget-table/widget-table.vue';

@Component({
  name: 'bpc-widget',
  components: {
    'bpc-widget-table': WidgetTable,
  },
})
export default class Widgets extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
